// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #ffffff;
}

.tree-loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.tree-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.tree-spinner {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  border: 3px solid transparent;
  border-bottom-color: #2563eb; /* blue-600 */
  animation: tree-spin 1s linear infinite;
}

@keyframes tree-spin {
  to {
    transform: rotate(360deg);
  }
}

.tree-loading-text {
  color: #4b5563; /* gray-600 */
  font-weight: 500;
}

.tree-canvas {
  position: absolute;
  inset: 0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  outline: 1px solid #e5e7eb; /* ring-gray-200 */
  overflow: hidden;
}

.tree-svg {
  width: 100%;
  height: 100%;
  display: block;
  -webkit-user-select: none;
          user-select: none;
}

.tree-node-rect {
  fill: #ffffff;
  stroke: #e5e7eb;
  stroke-width: 1;
}

.tree-node-rect.selected {
  fill: #dbeafe; /* blue-100 */
  stroke: #2b79c2;
  stroke-width: 2;
}

.tree-node-title {
  font-size: 12px;
  font-weight: 700;
  fill: #6b7280; /* gray-500 */
}

.tree-avatar {
  cursor: pointer;
}

.tree-avatar-circle {
  fill: #fff;
  stroke: #513cd2;
  stroke-width: 4;
}

.tree-avatar-icon {
  fill: #111827; /* gray-900 */
}

.tree-toggle {
  cursor: pointer;
}

.tree-toggle-plus {
  fill: #2b79c2;
}

.tree-toggle-plus-text {
  font-size: 14px;
  font-weight: 700;
  fill: #ffffff;
}

.tree-toggle-minus {
  fill: #ef4444; /* red-500 */
}

.tree-toggle-minus-text {
  font-size: 16px;
  font-weight: 800;
  fill: #ffffff;
}

.tree-sidebar {
  position: fixed;
  right: 1rem;
  top: 1rem;
  bottom: 1rem;
  width: 20rem; /* 320px */
  border-radius: 1rem;
  background: #ffffff;
  outline: 1px solid #e5e7eb;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  z-index: 50;
}

.tree-sidebar-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.75rem;
}

.tree-sidebar-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  background: #f3f4f6; /* gray-100 */
  display: grid;
  place-items: center;
  color: #4b5563; /* gray-600 */
}

.tree-sidebar-title {
  flex: 1 1;
}

.tree-sidebar-selected-label {
  font-size: 0.875rem;
  color: #6b7280; /* gray-500 */
}

.tree-sidebar-selected-name {
  font-weight: 600;
  color: #1f2937; /* gray-800 */
  font-size: 1rem;
  word-break: break-word;
  max-width: 220px;
}

.tree-sidebar-close {
  margin-left: 0.5rem;
  color: #9ca3af; /* gray-400 */
  background: transparent;
  border: none;
  cursor: pointer;
}
.tree-sidebar-close:hover {
  color: #4b5563; /* gray-600 */
}

.tree-sidebar-actions {
  margin-top: 1rem;
  display: grid;
  gap: 0.5rem;
}

.tree-action-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #374151; /* gray-700 */
  cursor: pointer;
}
.tree-action-btn:hover {
  border-color: #93c5fd; /* blue-300 */
  background: rgba(59, 130, 246, 0.06); /* blue-50/60 */
}

.tree-action-label {
  font-size: 0.875rem;
  font-weight: 500;
}

.tree-action-icon {
  color: #2563eb; /* blue-600 */
}

.tree-sidebar-help {
  margin-top: auto;
  padding-top: 1rem;
  font-size: 0.75rem;
  color: #9ca3af; /* gray-400 */
}


`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/Tree.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B,EAAE,aAAa;EAC3C,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,yCAAyC;EACzC,0BAA0B,EAAE,kBAAkB;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,aAAa;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa,EAAE,aAAa;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,aAAa;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa,EAAE,YAAY;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY,EAAE,UAAU;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,6EAA6E;EAC7E,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,mBAAmB,EAAE,aAAa;EAClC,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,aAAa;EAC7B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,aAAa;EAC7B,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc,EAAE,aAAa;EAC7B,eAAe;AACjB;AACA;EACE,qBAAqB,EAAE,aAAa;EACpC,oCAAoC,EAAE,eAAe;AACvD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc,EAAE,aAAa;AAC/B","sourcesContent":[".tree-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background: #ffffff;\n}\n\n.tree-loading-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n}\n\n.tree-loading-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.tree-spinner {\n  width: 48px;\n  height: 48px;\n  border-radius: 9999px;\n  border: 3px solid transparent;\n  border-bottom-color: #2563eb; /* blue-600 */\n  animation: tree-spin 1s linear infinite;\n}\n\n@keyframes tree-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.tree-loading-text {\n  color: #4b5563; /* gray-600 */\n  font-weight: 500;\n}\n\n.tree-canvas {\n  position: absolute;\n  inset: 0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  outline: 1px solid #e5e7eb; /* ring-gray-200 */\n  overflow: hidden;\n}\n\n.tree-svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  user-select: none;\n}\n\n.tree-node-rect {\n  fill: #ffffff;\n  stroke: #e5e7eb;\n  stroke-width: 1;\n}\n\n.tree-node-rect.selected {\n  fill: #dbeafe; /* blue-100 */\n  stroke: #2b79c2;\n  stroke-width: 2;\n}\n\n.tree-node-title {\n  font-size: 12px;\n  font-weight: 700;\n  fill: #6b7280; /* gray-500 */\n}\n\n.tree-avatar {\n  cursor: pointer;\n}\n\n.tree-avatar-circle {\n  fill: #fff;\n  stroke: #513cd2;\n  stroke-width: 4;\n}\n\n.tree-avatar-icon {\n  fill: #111827; /* gray-900 */\n}\n\n.tree-toggle {\n  cursor: pointer;\n}\n\n.tree-toggle-plus {\n  fill: #2b79c2;\n}\n\n.tree-toggle-plus-text {\n  font-size: 14px;\n  font-weight: 700;\n  fill: #ffffff;\n}\n\n.tree-toggle-minus {\n  fill: #ef4444; /* red-500 */\n}\n\n.tree-toggle-minus-text {\n  font-size: 16px;\n  font-weight: 800;\n  fill: #ffffff;\n}\n\n.tree-sidebar {\n  position: fixed;\n  right: 1rem;\n  top: 1rem;\n  bottom: 1rem;\n  width: 20rem; /* 320px */\n  border-radius: 1rem;\n  background: #ffffff;\n  outline: 1px solid #e5e7eb;\n  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  z-index: 50;\n}\n\n.tree-sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 0.75rem;\n}\n\n.tree-sidebar-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 9999px;\n  background: #f3f4f6; /* gray-100 */\n  display: grid;\n  place-items: center;\n  color: #4b5563; /* gray-600 */\n}\n\n.tree-sidebar-title {\n  flex: 1;\n}\n\n.tree-sidebar-selected-label {\n  font-size: 0.875rem;\n  color: #6b7280; /* gray-500 */\n}\n\n.tree-sidebar-selected-name {\n  font-weight: 600;\n  color: #1f2937; /* gray-800 */\n  font-size: 1rem;\n  word-break: break-word;\n  max-width: 220px;\n}\n\n.tree-sidebar-close {\n  margin-left: 0.5rem;\n  color: #9ca3af; /* gray-400 */\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n.tree-sidebar-close:hover {\n  color: #4b5563; /* gray-600 */\n}\n\n.tree-sidebar-actions {\n  margin-top: 1rem;\n  display: grid;\n  gap: 0.5rem;\n}\n\n.tree-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  color: #374151; /* gray-700 */\n  cursor: pointer;\n}\n.tree-action-btn:hover {\n  border-color: #93c5fd; /* blue-300 */\n  background: rgba(59, 130, 246, 0.06); /* blue-50/60 */\n}\n\n.tree-action-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.tree-action-icon {\n  color: #2563eb; /* blue-600 */\n}\n\n.tree-sidebar-help {\n  margin-top: auto;\n  padding-top: 1rem;\n  font-size: 0.75rem;\n  color: #9ca3af; /* gray-400 */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
